import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EDTutor, TutorListParams} from "../../models/serverModels/education/EDTutor";

const education = axios.create({
  baseURL: "/API",
});

export const getList = async (params: TutorListParams): Promise<ResponseList<EDTutor>> =>
  education({
    url: "/TutorList",
    method: "get",
    params,
  }).then((res) => res.data);
export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EDTutor>> =>
  education({
    url: `/Tutor/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (param: Params.Create<EDTutor>): Promise<ResponseItem<EDTutor>> =>
  education({
    url: `/Tutor/`,
    method: "post",
    data: param,
  }).then((res) => res.data);

export const remove = async (param: Params.Remove): Promise<ResponseRemove> =>
  education({
    url: `/Tutor/${param.id}`,
    method: "delete",
    data: param,
  }).then((res) => res.data);

export const update = async (param: Params.Update<EDTutor>): Promise<ResponseItem<EDTutor>> =>
  education({
    url: `/Tutor/${param.id}`,
    method: "put",
    data: param,
  }).then((res) => res.data);
